import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPajakTerutangService = new CrudCustom('/transaksi-pajak-terutangs');
export default TransaksiPajakTerutangService;
